import { supabaseClient } from "supabase";

export const deleteImage = async (
  filePath: string,
  bucketName: string
): Promise<void> => {
  const parts = filePath.split("/");
  const newFilePath = parts.slice(parts.length - 2).join("/");

  await supabaseClient.storage.from(bucketName).remove([newFilePath]);
};
